import * as React from 'react';

import { CitationModule } from '@coursera-web/cds-labs';

import type { EnterpriseSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/EnterpriseSpecializationPageQuery';
import { getCareerOutcomesEnterpriseDisclaimers } from 'bundles/unified-description-page-common/utils/careerOutcomes';

type Props = {
  pageData: EnterpriseSpecializationPageFieldsFragment;
};

const EnterpriseSpecializationCitationModuleRenderer = ({ pageData }: Props) => {
  if (!pageData.careerOutcomes?.careerGrowthInPercentage) return null;
  return <CitationModule removeTopPadding citations={getCareerOutcomesEnterpriseDisclaimers()} />;
};

export default EnterpriseSpecializationCitationModuleRenderer;
